import {
  LOAD_ITEMS,
  SORT_FAILURE,
  SORT_SUCCESS,
  SORT_INTENT
} from "../constants";
import { CLEAR_ERRORS_BY_TYPE, ERROR } from "../../common/constants";
import { ServiceError } from "../../../../services/errors";
import { getSavedItemsResetFromStart } from "../../../actions";
import clientConfigurationProvider from "../../../../providers/clientConfigurationProvider";

export const changeSort =
  ({ sort, sortOrder }) =>
  async dispatch => {
    dispatch({
      type: SORT_INTENT,
      payload: {
        sort,
        sortOrder
      }
    });

    const { changeSortGetItemsRetriesBackoff: retryBackoffs } =
      clientConfigurationProvider();

    let response;
    try {
      response = await dispatch(getSavedItemsResetFromStart({ retryBackoffs }));
    } catch (e) {
      if (!(e instanceof ServiceError)) {
        throw e;
      }
      dispatch({
        type: CLEAR_ERRORS_BY_TYPE,
        payload: [LOAD_ITEMS, SORT_INTENT]
      });
      dispatch({ type: SORT_FAILURE });
      dispatch({
        type: ERROR,
        payload: {
          failedActionType: SORT_INTENT,
          canBeRetried: true,
          sort,
          sortOrder
        }
      });

      return;
    }
    if (response === null) {
      return;
    }

    dispatch({ type: SORT_SUCCESS });
  };
